<template>
    <div
        class="pt-10 pb-10 px-2 sm:px-8 bg-contain"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
            backgroundColor: '#fe0084'
        }"
    >
        <slot></slot>

        <div class="container m-auto pt-10">
            <h1 class="font-primary text-4xl text-white text-center mb-10">
                {{ $config("SERIE") }}
            </h1>

            <div class="w-full max-w-screen-2xl mx-auto flex flex-wrap">
                <div
                    v-for="(serie, index) in series"
                    :key="index"
                    class="w-full sm:w-1/2 lg:w-1/3 px-4 mb-10"
                >
                    <router-link
                        :to="{ name: 'serie', params: { id: serie.id } }"
                        :alt="serie.title"
                    >
                        <app-image
                            width="310"
                            height="175"
                            :url="serie.more.preview"
                            class="mb-2 rounded-lg"
                            :alt="serie.title"
                            lazy
                        >
                        </app-image>
                    </router-link>

                    <p
                        class="font-primary text-xl text-white text-center sm:text-left"
                    >
                        {{ serie.title }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "series-grid-section",

    props: {
        series: {
            type: Array,
            required: true,
            default: () => []
        }
    }
};
</script>
